/*import { SupervisedUserCircleTwoTone } from '@material-ui/icons';
import { logDOM } from '@testing-library/react'
import axios from 'axios'
import { id } from 'date-fns/locale';
import L from "leaflet";*/
import './ClickOnMap.css'
import copy from './copy.png'
import i18n from 'i18next';

//funzione per creare le stringhe di informazion che riempiono l'info popup
function findService(element, value) {
  return element === value.serviceUrl
}

function compareNull(string) {
  return (string === null || string === "NA" || string === undefined  ) ? "" : string
}
export default function createStringDiv(layer, latlng) {
  
  try {
    const service = window.configFile.serviceOnScreen.services
    const serviceLayer = service.filter(res => res.serviceUrl.indexOf(layer.url_service) !== -1)

    let nomeFermata = ""
    let regione = ""
    let comune = ""
    let type = ""
    let agency_id = ""
    let coordinateObject = {}
    //let layerPaths = null
    let stringaPopup = `<h2 class="titoloPopUp">${i18n.t(layer.nome)}</h2>
                              <table style="width:100%">`

    //await axios.get(layer.url)

      //.then(response => {

        //const paths = response.data
    const paths = layer.info
    //layerPaths = paths

    if (paths.features[0] === undefined) {
    } else {
      paths.features.map(b => {
        let trovato = false
        serviceLayer.map(x => {
          let a = x.layersName.findIndex(element => element === layer.nome)
          if (a === -1 && x.layersDisplayName) a = x.layersDisplayName.findIndex(element => element === layer.nome)
          if (a !== -1) {
            trovato = true
            x.infoFields.layers[a].fields.map(x => {

              if (x.visible === true &&  b.properties[x.fieldName]) {
                b.properties[x.fieldName].includes("loghi") ? b.properties[x.fieldName] = `<img src="${"/" + b.properties[x.fieldName]}" width="32" height="32">` : b.properties[x.fieldName] = b.properties[x.fieldName];
                //compareNull(b.properties[x.fieldName]).includes("http") ?
                (x.fieldName.includes("url") && compareNull(b.properties[x.fieldName]) !== "") ?
                  stringaPopup += `<tr><th class="rowStyle">${i18n.t(x.fieldLabel)}</th> <td class="tdStyle"><a target='_orari' href="${b.properties[x.fieldName]}" >${i18n.t('Visualizza Real Time')}</a></td></tr>`:
                  stringaPopup += `<tr><th class="rowStyle">${i18n.t(x.fieldLabel)}</th> <td class="tdStyle">${compareNull(b.properties[x.fieldName])}</td></tr>`;
              }
              if(x.flagLatitudine) coordinateObject.latitudine=b.properties[x.fieldName]
              if(x.flagLongitudine) coordinateObject.longitudine=b.properties[x.fieldName]
              if(x.flagNome) nomeFermata=b.properties[x.fieldName]
              if (x.flagRegione === true) {
                regione = b.properties[x.fieldName]
              }
              if (x.fieldName.includes("agency_id") && compareNull(b.properties[x.fieldName]) !== "") agency_id=b.properties[x.fieldName];
            })
          }

        })
        if (b.properties['stop_comune'] ) comune = b.properties['stop_comune']
        if (b.properties['stop_type'] ) type = b.properties['stop_type']
        if(!trovato) {
          if (b.properties['stop_name'] ) nomeFermata = b.properties['stop_name']
          stringaPopup += `<tr><th class="rowStyle">${i18n.t('Nome')}</th> <td class="tdStyle">${compareNull(nomeFermata)}</td></tr>`;
          if (compareNull(b.properties.stop_id)) stringaPopup += `<tr><th class="rowStyle">${i18n.t('Codice')}</th> <td class="tdStyle">${compareNull(b.properties.stop_id)}</td></tr>`;
          stringaPopup += `<tr><th class="rowStyle">${i18n.t('Latitudine')}</th> <td class="tdStyle">${latlng.lat}</td></tr>`;
          stringaPopup += `<tr><th class="rowStyle">${i18n.t('Longitudine')}</th> <td class="tdStyle">${latlng.lng}</td></tr>`;
        }
      })
    }
         
    stringaPopup += '</table>'
    if(!coordinateObject.latitudine) coordinateObject.latitudine=latlng.lat
    if(!coordinateObject.longitudine) coordinateObject.longitudine=latlng.lng
    if(!nomeFermata) nomeFermata=i18n.t(layer.nome)

    if (paths.features.length > 0 && paths.features[0].properties.stop_id) {

      return { id: paths.features[0].properties.stop_id, value: stringaPopup, coordinate: coordinateObject, fermata: nomeFermata, regione: regione, agency_id: agency_id, comune: comune, type: type };
      /*if (layerPaths.features[0].properties.stop_id !== undefined) 
      return { id: layerPaths.features[0].properties.stop_id, value: stringaPopup, coordinate: coordinateObject, fermata: nomeFermata, regione: regione };
      else return { id: "", value: stringaPopup, coordinate: coordinateObject, fermata: nomeFermata, regione: regione };*/
    } else { return { id: "", value: stringaPopup, coordinate: coordinateObject, fermata: nomeFermata, regione: regione, agency_id: agency_id, comune: comune, type: type }; }

  } catch (error) {
    
     let stringaPopup = ""
     if(latlng.lat && latlng.lat.toFixed) {
      stringaPopup += `<img src=${copy} id='copia' onclick='navigator.clipboard.writeText("${latlng.lat},${latlng.lng}");alert("${i18n.t('Coordinate copiate')}")'></img>`
      stringaPopup += `${i18n.t("Latitudine")}: ${latlng.lat.toFixed(6)} <br>${i18n.t("Longitudine")}: ${latlng.lng.toFixed(6)}`
      }
    return { id: "", value: stringaPopup }

  }

}

